import React from 'react';
import { useQueryString } from 'helpers/effects';
import CreditList from 'components/Credit/List';

const ScreenCreditList = () => {
  const initialFilters = useQueryString();
  return <CreditList initialFilters={initialFilters} />;
};

export default ScreenCreditList;
